const DENTR_SCRIPT_ID = 'dentr-widget-script';
const DENTR_SCRIPT_SRC = 'https://widgets.dentr.co.uk/v2/dentr.v2.min.js';
const DENTR_TRIGGER_CLASS = 'dentr-popup';
const DENTR_SHORT_ID = 'Indigo-Dental-Practice';

export function initDentrWidget() {
  if (!document.querySelector(`.${DENTR_TRIGGER_CLASS}`)) {
    return;
  }

  window.dentr_ButtonClass = `.${DENTR_TRIGGER_CLASS}`;
  window.dentr_short_id = DENTR_SHORT_ID;

  if (document.getElementById(DENTR_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  const firstScript = document.getElementsByTagName('script')[0];

  script.id = DENTR_SCRIPT_ID;
  script.async = true;
  script.src = DENTR_SCRIPT_SRC;
  script.charset = 'UTF-8';
  script.setAttribute('crossorigin', '*');

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
}
